import { useRef, useEffect } from "react";
import { useSoundContext } from "../../SoundContext";

export default function useBGM(audioPath, loop = true) {
  const audioRef = useRef(null);
  const { isMuted } = useSoundContext();

  useEffect(() => {
    if (!audioPath) return;

    audioRef.current = new Audio(audioPath);
    audioRef.current.loop = loop;
    audioRef.current.volume = 0.5;

    // 전역 음소거 상태에 따라 볼륨 조절
    audioRef.current.muted = isMuted;

    audioRef.current.play().catch((err) => {
      console.warn("BGM 자동 재생 차단됨 (사용자 상호작용 필요):", err.message);
    });

    return () => {
      if (audioRef.current) {
        audioRef.current.pause();
        audioRef.current = null;
      }
    };
  }, [audioPath, loop]);

  // isMuted 상태 변경 시 즉시 반영
  useEffect(() => {
    if (audioRef.current) {
      audioRef.current.muted = isMuted;
    }
  }, [isMuted]);
}
